import { useFindFaireDirectBrandTokenOrAliasForCurrentPage } from "@faire/deprecated-retailer-visitor-shared/app/_lib/faire-direct-visitor/faire-direct/useFindFaireDirectBrandTokenOrAliasForCurrentPage";
import { whitelist } from "@faire/deprecated-retailer-visitor-shared/initializers/AutoSignUpInitializer";
import { useIsSemDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { useIsFaireDirectActiveInLoggedOut } from "@faire/faire-direct/lib/hooks/useIsFaireDirectActiveInLoggedOut/useIsFaireDirectActiveInLoggedOut";
import { useIsFaireDirectActiveForVisitor } from "@faire/faire-direct/lib/visitor/useIsFaireDirectBrandForVisitor";
import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { RouteMatcher } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";

import { useSettingEnableDiscoverCategoryCTABanners } from "../../../settings/useSettingEnableDiscoverCategoryCTABanners";

export const useIsEligibleForMobileLoggedOutNavWithCartSignUp = (): boolean => {
  const isSemDiscoverPage = useIsSemDiscoverPage();
  const { isMobile } = useViewport();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const matcher = new RouteMatcher(whitelist);
  const location = useLocation();
  const isPageOnAllowedList =
    matcher.match(location?.pathname ?? "") !== undefined;
  const host = getWindowOrThrow().location.host;
  const isFaireTech = host.includes("faire.tech");
  const discoverCategoryCTABannersVariant =
    useSettingEnableDiscoverCategoryCTABanners();
  const isFaireDirectActiveInControl = useIsFaireDirectActiveInLoggedOut();
  const brandTokenOrBrandAlias =
    useFindFaireDirectBrandTokenOrAliasForCurrentPage();
  const isFaireDirectActiveForVisitor = useIsFaireDirectActiveForVisitor(
    brandTokenOrBrandAlias,
    isFaireDirectActiveInControl
  );

  return (
    !isSemDiscoverPage &&
    isMobile &&
    !isLoggedInRetailer &&
    isPageOnAllowedList &&
    !isFaireTech &&
    !isFaireDirectActiveForVisitor &&
    discoverCategoryCTABannersVariant !== IThreeVariantXP.Bucket.VARIANT_2
  );
};
